import { PaymentMethod } from "@omni/types/components/payment/paymentMethod.model";

import { PaymentMethodsConfig } from "@/components/Checkout/Payment/paymentMethods/paymentMethod/paymentMethods.config";

const sortPaymentMethods = (a: PaymentMethod, b: PaymentMethod) => {
    const aIndex = PaymentMethodsConfig.sorting.indexOf(a.code);
    const bIndex = PaymentMethodsConfig.sorting.indexOf(b.code);

    return aIndex - bIndex;
};

export const getPreSelectedPaymentMethod = (
    paymentMethods: Array<PaymentMethod>
) =>
    paymentMethods.find(
        ({ selected, code }) =>
            selected && !PaymentMethodsConfig.nonPreSelectable.includes(code)
    );

export const splitPaymentMethods = (allPaymentMethods: Array<PaymentMethod>) =>
    allPaymentMethods.sort(sortPaymentMethods).reduce(
        ({ paymentMethods, isGiftCardPayment }, paymentMethod) =>
            PaymentMethodsConfig.giftCard.includes(paymentMethod.code)
                ? {
                      paymentMethods: paymentMethods,
                      isGiftCardPayment: true
                  }
                : {
                      paymentMethods: [...paymentMethods, paymentMethod],
                      isGiftCardPayment: isGiftCardPayment
                  },

        {
            paymentMethods: [] as Array<PaymentMethod>,
            isGiftCardPayment: false
        }
    );
